import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg
      fill="#00A76F"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm-2 17.41-4.41-4.42L7 11l3 3 7-7 1.41 1.41Z" />
    </svg>
  )
}

export default SvgComponent
